import type { ReactNode } from 'react'

import { LoadingSpinner } from '@/customer/components/loading-spinner'
import { NotFound } from '@/customer/components/not-found'
import { useIsImpersonated } from '@/customer/hooks/use-is-impersonated'

/**
 * Renders its children only for sessions minted by staff impersonation;
 * everyone else gets the standard 404 so the route stays invisible. This is
 * UX only: the matching backend routes enforce the same rule.
 */
export function ImpersonationOnly({ children }: { children: ReactNode }) {
  const { isPending, isImpersonated } = useIsImpersonated()

  if (isPending) return <LoadingSpinner />
  if (!isImpersonated) return <NotFound />
  return <>{children}</>
}
